import styles from "../../constants/styles";

const LinkButton = () => {
  return (
    <a
      href="https://chrome.google.com/webstore/detail/duolingo-vocabulary-downl/ianhccjmhhopfhamaijdijafpljdiohi"
      target="_blank"
      rel="noreferrer"
      className={`${styles.hoverShrinkEffect} text-lg text-white p-5 bg-green-500 hover:bg-green-400 rounded-xl w-fit h-fit`}
    >
      <span>Download Extension</span>
    </a>
  );
};

export default LinkButton;
